export default "__VITE_ASSET__CA0zrB_b__"